const BASE_ENV: Env = {
  API_BASE_URL: {
    LOC: 'http://localhost:3000/api',
    DEV: 'https://dev-api.sktapollo.com',
    STG: 'https://stg-api.sktapollo.com',
    PRD: 'https://api.sktapollo.com'
  }
}

export default BASE_ENV
